const getSunglassesProductFeatures = (lensFeatures)=>{
    const { isGlazeble , isPolarized , uvRaysProtection  } = lensFeatures;
    const productFeatures = [];
    if (!!uvRaysProtection) {
        productFeatures.push({
            type: 'uvCategory',
            iconName: 'uv',
            labelKey: 'products.sunglasses.features.uvCategory'
        });
    }
    if (!!isPolarized) {
        productFeatures.push({
            type: 'polarized',
            iconName: 'polarized',
            labelKey: 'products.sunglasses.features.polarized'
        });
    }
    if (!!isGlazeble) {
        productFeatures.push({
            type: 'glazeable',
            iconName: 'reading',
            labelKey: 'products.sunglasses.features.glazeable'
        });
    }
    return productFeatures;
};

export { getSunglassesProductFeatures };
//# sourceMappingURL=get-sunglasses-product-features.js.map
